import axios from '@axios'

export const fetchGroupTypesForSelect = async (params?: any): Promise<any> => {
  const res = await axios.get('/auth/group-types-for-select', { params })
  return res
}

export const _ = null
